import { Injectable } from '@angular/core';

declare global {
  interface Window {
    __TAURI__?: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ExternalLinkService {

  /**
   * Opens an external URL
   * - In Tauri: uses @tauri-apps/plugin-opener to open in system browser
   * - In Web: allows default anchor behavior (not blocked)
   */
  async openExternal(url: string, event?: Event): Promise<void> {
    try {
      // Check if running in Tauri
      if (this.isTauri()) {
        // Prevent default anchor behavior in Tauri
        event?.preventDefault();
        console.log('🚀 [Tauri] Opening external URL with opener plugin:', url);

        // Import and use the Tauri Opener plugin
        const { openUrl } = await import('@tauri-apps/plugin-opener');
        await openUrl(url);

        console.log('✅ [Tauri] URL opened successfully');
      } else {
        // In web, let the anchor tag handle it naturally (won't be blocked)
        console.log('🌐 [Web] Opening external URL via anchor tag:', url);
        // Don't preventDefault - let the <a> tag work naturally
      }
    } catch (error) {
      console.error('❌ Failed to open external URL:', error);
      // Fallback to window.open if anything fails
      if (event) event.preventDefault();
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  /**
   * Check if running in Tauri environment
   */
  isTauri(): boolean {
    return !!window.__TAURI__;
  }
}

